export default __webpack_public_path__ + "static/media/save-costs.e05d7d30.png";